import {
  actions,
  getAnswersAsDataTableAsync,
  getAnswersByQuestionIdAsync,
  createNewAnswerAsync,
  editAnswerAsync,
  setCorrectAnswerAsync,
  deleteAnswerAsync,
} from './slices';

export const AnswersActions = {
  ...actions,
  getAnswersAsDataTableAsync,
  getAnswersByQuestionIdAsync,
  createNewAnswerAsync,
  editAnswerAsync,
  setCorrectAnswerAsync,
  deleteAnswerAsync,
};
